import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'topo-ip-restricted',
    templateUrl: './ip-restricted.component.html',
    styleUrls: ['./ip-restricted.component.scss'],
    standalone: false
})
export class IpRestrictedComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  constructor() { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete()
  }

  ngOnInit(): void {

  }
}
